import styled from 'styled-components';

export const DetalhesPrint = styled.div`
  width: 100%;
  padding: 1rem;
  display: flex;
  justify-content: space-between;

  p {
    font-family: 'Roboto';
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: #71717a;

    div {
      font-family: 'Roboto';
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #000000;
    }
  }
  .ant-form-item-label {
    font-size: 13px;
    font-weight: 400;
    padding: 0;
    margin-bottom: 5px;
  }

  label {
    display: block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .box {
    background-color: #fafafa;
    border: 1px solid #f0f0f0;
    padding: 1rem 1rem 0 1rem;
  }
  .notas {
    display: flex;
    ul {
      padding: 0 0 0 5px;
      li {
        list-style: none;
      }
    }
  }
`;

export const Documentos = styled.div`
  h2 {
    color: #096dd9;
    font-weight: 400;
    font-size: 20px;
    text-align: center;
    font-weight: 500;
  }
`;
